import {PracticesService} from "../../../services/practices.service";

export interface ExpiryOption {
  // The value sent to/received from the Rails backend
  backendValue: 'ten' | 'thirty' | 'sixty' | 'ninety' | 'one_twenty' | 'two_fourty';
  // The value displayed to the user
  displayValue: string;
}

export const SESSION_EXPIRY_OPTIONS: ExpiryOption[] = [
  { backendValue: 'ten', displayValue: '10 minutes' },
  { backendValue: 'thirty', displayValue: '30 minutes' },
  { backendValue: 'sixty', displayValue: '60 minutes (1 hour)' },
  { backendValue: 'ninety', displayValue: '90 minutes (1.5 hours)' },
  { backendValue: 'one_twenty', displayValue: '120 minutes (2 hours)' },
  { backendValue: 'two_fourty', displayValue: '240 minutes (4 hours)' }
];



import {Component, Input, OnInit} from '@angular/core';
import {CustomHttpClient} from "../../../services/custom-http-client.service";
import {Practice} from "../practices/practice";
import {GlobalErrorHandlerService} from "../../../services/global-error.service";
import {AlertService} from "../../../_alert";
import {LoaderService} from "../../../services/loader.service";

@Component({
  selector: 'app-session-warning-settings',
  templateUrl: './session-warning-settings.component.html',
  styleUrls: ['./session-warning-settings.component.scss']
})
export class SessionWarningSettingsComponent implements OnInit {
  @Input() practice: Practice;
  expiryOptions: ExpiryOption[] = SESSION_EXPIRY_OPTIONS;
  currentExpirySetting: string | undefined;
  lastSavedBackendValue: 'ten' | 'thirty' | 'sixty' | 'ninety' | 'one_twenty' | 'two_fourty';

  constructor(
    private _tokenService: CustomHttpClient,
    public practiceService: PracticesService,
    public globalErrorHandlerService: GlobalErrorHandlerService,
    public alertService: AlertService,
    public loaderService: LoaderService,
  ) {  }

  ngOnInit(): void {
    this.loadCurrentSettings();
  }

  loadCurrentSettings(): void {
    this._tokenService.get('practices/get_session_timeout').subscribe(config => {
      this.currentExpirySetting = config.session_expiry_minutes;
    });
  }
  onSettingChange(): void {
    if (this.currentExpirySetting) {
      this.loaderService.show();
      console.log(`New setting selected: ${this.currentExpirySetting}`);
      this.practice.session_expiry_minutes = this.currentExpirySetting

      this.practiceService.save(this.practice).then(res => {
        this.practice = this.practice.load_from_json(res);
        this.loaderService.hide();
        this.alertService.success('Update successful', this.alertService.options)
      }).catch(resp =>  {
        this.loaderService.hide();
        this.globalErrorHandlerService.error = resp.error.error
      } );
    }
  }

}
